class ChangeAccountAvatar {
    constructor() {
        this.editAccountAvatar();
    }
    editAccountAvatar(){
        const thisClass = this;
        /** Open avatars modal */
        $(document).on('click', '#account-block-menu #editAccountAvatarBtn', function(e) {
            new bootstrap.Modal(document.getElementById('change_account_avatar_modal'), {}).show();
        });
        /** Open avatars modal */
        $(document).on('click', '#change_account_avatar_modal .symbol', function(e) {
            let img = $(this).find('img');
            let avatarSrc = (img[0].getAttribute('src')).replace(/ /g, "%20");
            thisClass.addOrRemoveContentLoading();
            $.ajax({
                url: '?do=changeAvatar',
                type: 'POST',
                dataType: '',
                data: { avatarID: $(this).find('img')[0].getAttribute('data-value')}
            }).done(function(data) {
                if(data){
                    toastr.success('Account avatar has been successfully changed.');
                    $('#account-block-menu #account-avatar, #kt_app_header #header-account-menu-avatar, #kt_app_header #header-account-avatar').attr('src', avatarSrc);
                } else {
                    toastr.error('Unexpected error occurred. Please try it again later.');
                }
                thisClass.addOrRemoveContentLoading();
                // document.querySelector('#change_account_avatar_modal').classList.remove('block-ui');
                bootstrap.Modal.getInstance(document.getElementById('change_account_avatar_modal')).hide();
            });
        });
    }
    addOrRemoveContentLoading(){
        // Init block ui
        const element = document.querySelector('#change_account_avatar_modal .modal-content');
        if(element){
            let blockUI = KTBlockUI.getInstance(element);
            if(!blockUI){
                blockUI = new KTBlockUI(element, {
                    overlayClass: "ga-bg-primary-200",
                });
            }
            if (blockUI.isBlocked()) {
                blockUI.release();
            } else {
                blockUI.block();
            }
        }
    }
}
window.ChangeAccountAvatar = ChangeAccountAvatar;